import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=db61f45e&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db61f45e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db61f45e')) {
      api.createRecord('db61f45e', component.options)
    } else {
      api.reload('db61f45e', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=db61f45e&scoped=true&", function () {
      api.rerender('db61f45e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4vB46NYzGL6sF/JS/comp/Voucher-Unit.vue"
export default component.exports